/**
 * Builds the payload for `PUT /candidates/:id`.
 *
 * The status dropdown in the candidate form is seeded from the candidate
 * record that was loaded when the page opened. Sending that value on every
 * save would overwrite a newer status - for example a screening decision
 * ("screen_selected") that was submitted by the hiring manager while the page
 * was open - and could silently move the candidate back to "screen_pending".
 *
 * So `status` is only sent when the user actually changed the dropdown.
 * Without it the backend keeps the stored status untouched.
 */
export const buildCandidateUpdatePayload = (formData, { candidate, note } = {}) => {
  const payload = { ...formData, note };

  const currentStatus = String(candidate?.status ?? '').trim();
  const formStatus = String(formData?.status ?? '').trim();

  if (currentStatus && formStatus && currentStatus === formStatus) {
    delete payload.status;
  }

  return payload;
};
